<template>
    <div class="toasts-container" style="z-index: 1000000">
        <div v-for="(toast) of messages" :key="toast.id" :class="'alert alert-dismissible fade-in-down alert-' + toast.type">
            <div><strong>{{toast.title}}</strong></div>
            <div class="small" v-if="toast.content">{{toast.content}}</div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="dismissToast(toast.id)">
                <span aria-hidden="true"><Icon icon-name="close-outline"></Icon></span>
            </button>
        </div>
    </div>
</template>

<script>
    import Icon from '@shared/components/Icon'
    import Vue from 'vue'

    export default {
        name: 'Toasts',
        components: { Icon },
        data () {
            return {
                messages: []
            }
        },
        mounted () {
            Vue.$errorToast = Vue.prototype.$errorToast = this.errorToast
            Vue.$successToast = Vue.prototype.$successToast = this.successToast
        },
        methods: {
            dismissToast (id) {
                this.messages.splice(this.messages.findIndex(toast => toast.id === id), 1)
            },

            errorToast(title, content) {
                this.messages.push({ id: Math.random(), type: 'danger', title: title, content: content })
            },

            successToast(title, content) {
                const id = Math.random()
                this.messages.push({ id: id, type: 'success', title: title, content: content })
                setTimeout(() => { this.dismissToast(id) }, 5000)
            }
        }
    }
</script>
